import script from "./WalletPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./WalletPage.vue?vue&type=script&setup=true&lang=ts"

import "./WalletPage.vue?vue&type=style&index=0&id=0a3583f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a3583f4"]])

export default __exports__